import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getStreamsList, getUserData } from '../../../api/streams';

import { generateStreamCIDKey } from '../../../components/Streams/utils/generateStreamCIDKey';
import { mergeStreamsListWithUserData } from '../../../utils/streams';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const fetchStreamList = createAsyncThunk(
  'streams/fetchStreamList',
  async (streamData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const streamsResponse = await getStreamsList(
        { ...streamData, params: { full: 'full' } },
        {
          cancelToken: source.token,
        },
      );
      const streamsUserDataResponse = { data: {} };

      await Promise.all(
        streamsResponse.data.map(async stream => {
          const { data } = await getUserData({
            path: { orgId: stream.orgId, streamId: stream.id },
          });
          streamsUserDataResponse.data[generateStreamCIDKey(data.streamCID)] =
            data;
        }),
      );

      return mergeStreamsListWithUserData(
        streamsResponse,
        streamsUserDataResponse,
      );
    } catch (error) {
      return rejectWithValue(error.response?.status);
    }
  },
);

export const fetchStreamListExtraReducers = builder => {
  builder
    .addCase(fetchStreamList.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.streams.byOrg.request,
        action,
        action.meta.arg.path.orgId,
      );
    })
    .addCase(fetchStreamList.fulfilled, (state, action) => {
      const orgCIDKey = action.meta.arg.path.orgId;
      state.streams.byOrg.allIds[orgCIDKey] = [];

      onMatchedRequest(state.streams.byOrg.request[orgCIDKey], action, () => {
        action.payload.streams.forEach(stream => {
          const streamCIDKey = generateStreamCIDKey(stream);

          state.streams.stream.byId[streamCIDKey] = stream;

          if (!state.streams.stream.allIds.includes(streamCIDKey)) {
            state.streams.stream.allIds.push(streamCIDKey);
          }

          if (!state.streams.byOrg.allIds[orgCIDKey]) {
            state.streams.byOrg.allIds[orgCIDKey] = [];
          }

          state.streams.byOrg.allIds[orgCIDKey].push(streamCIDKey);
        });
      });
    })
    .addCase(fetchStreamList.rejected, (state, action) => {
      handleRequestRejection(
        state.streams.byOrg.request[action.meta.arg.path.orgId],
        action,
      );
    });
};
